import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propStr, propChildren } from '../../../helpers/custom-prop-types';
import Hover from '../../Ui/System/Hover';
const HeaderLoginSideMenuContentLink = (props) => {
    const { children, className, pathname, to } = props;
    return (_jsx(Hover, { children: pathname === to ? (_jsx("a", Object.assign({ className: className, href: to }, { children: children }))) : (_jsx(Link, Object.assign({ className: className, to: to }, { children: children }))) }));
};
HeaderLoginSideMenuContentLink.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    pathname: propStr().isRequired,
    to: propStr().isRequired,
};
HeaderLoginSideMenuContentLink.defaultProps = {
    className: '',
};
export default HeaderLoginSideMenuContentLink;
